/* eslint-disable import/no-named-as-default-member */
const FUNDS = {
  9118: {
    id: "4",
    name: "Compass DVA Multiaxis",
    fundRun: 9118,
    shortName: "Multiaxis",
    currency: "USD",
    fixedFee: "1,2%",
    fundType: "equity",
    geoDistribution: "Global",
    rut: "76.121.258-3",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "28992393",
    email: "clientes@dvacapital.com",
    timeHorizon: "LONG",
    icon: "web",
    redemptionPeriod: "fromFiveDays",
    color: "#4E5FF1",
    highestRecommendedProfilingScore: 14,
    retailSeriesNemo: "CFIAMDVAMA",
  },

  9362: {
    id: "11",
    name: "Compass Acciones Chilenas",
    shortName: "Acciones Chilenas",
    fundRun: 9362,
    currency: "CLP",
    fixedFee: "1,19%",
    fundType: "equity",
    geoDistribution: "Chile",
    rut: "76.618.593-2",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "10732454",
    email: "clientes@dvacapital.com",
    timeHorizon: "LONG",
    icon: "star-outline",
    redemptionPeriod: "fromTwoDays",
    color: "#00AA9D",
    highestRecommendedProfilingScore: 14,
    retailSeriesNemo: "CFMCACHDVA",
  },

  9725: {
    id: "2",
    name: "Compass DVA Silicon Fund",
    shortName: "Silicon Fund",
    fundRun: 9725,
    currency: "USD",
    fixedFee: "0.95%",
    fundType: "equity",
    geoDistribution: "Global",
    rut: "76.989.370-9",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "28997034",
    email: "clientes@dvacapital.com",
    timeHorizon: "LONG",
    icon: "memory",
    redemptionPeriod: "fromFiveDays",
    color: "#FF0079",
    highestRecommendedProfilingScore: 14,
    retailSeriesNemo: "CFIAMDVASC",
  },

  9937: {
    id: "5",
    name: "Compass DVA Medtech",
    shortName: "Medtech",
    fundRun: 9937,
    currency: "USD",
    fixedFee: "1,19%",
    fundType: "equity",
    geoDistribution: "Global",
    rut: "77.235.629-3",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "30389631",
    email: "clientes@dvacapital.com",
    timeHorizon: "LONG",
    icon: "needle",
    redemptionPeriod: "fromFiveDays",
    color: "#832FED",
    highestRecommendedProfilingScore: 14,
    retailSeriesNemo: "CFIAMDVATA",
  },

  9958: {
    id: "6",
    name: "Compass DVA Deuda Privada USA",
    shortName: "Deuda Privada USA",
    fundRun: 9958,
    currency: "USD",
    fixedFee: "1,19%",
    fundType: "alternatives",
    geoDistribution: "EEUU",
    rut: "77.274.873-6",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "30390290",
    email: "clientes@dvacapital.com",
    timeHorizon: "MEDIUM",
    icon: "shield-star-outline",
    redemptionPeriod: "fromFiveDays",
    color: "#135D75",
    highestRecommendedProfilingScore: 14,
    retailSeriesNemo: "CFIAMDVADA",
  },

  10431: {
    id: "12",
    name: "Compass Liquidez FM",
    shortName: "Liquidez",
    fundRun: 10431,
    currency: "CLP",
    fixedFee: "0,8925%",
    fundType: "fixedIncome",
    geoDistribution: "Chile",
    rut: "77.726.524-5",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "10732446",
    email: "clientes@dvacapital.com",
    timeHorizon: "SHORT",
    icon: "lock-outline",
    redemptionPeriod: "oneDay",
    color: "#C50076",
    highestRecommendedProfilingScore: null,
    retailSeriesNemo: "CFMCGLQDVA",
  },

  10275: {
    id: "10",
    name: "Compass Equilibrio",
    shortName: "Equilibrio",
    fundRun: 10275,
    currency: "CLP",
    fixedFee: "1.19%",
    fundType: "mixedFunds",
    geoDistribution: "Global",
    rut: "77.591.193-K",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "10727019",
    email: "clientes@dvacapital.com",
    timeHorizon: "SHORT",
    icon: "flag-outline",
    redemptionPeriod: "fromTwoDays",
    color: "#CA9328",
    highestRecommendedProfilingScore: 11,
    retailSeriesNemo: "CFMCGEQLD",

  },

  10348: {
    id: "8",
    name: "Compass DVA E-Fund",
    shortName: "E-Fund",
    fundRun: 10348,
    currency: "USD",
    fixedFee: "1.19%",
    fundType: "equity",
    geoDistribution: "Global",
    rut: "77.656.122-3",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "30398274",
    email: "clientes@dvacapital.com",
    timeHorizon: "LONG",
    icon: "lightning-bolt-outline",
    redemptionPeriod: "fromFiveDays",
    color: "#1EC26A",
    highestRecommendedProfilingScore: 14,
    retailSeriesNemo: "CFIADVAEFA",
  },

  7200: {
    id: "13",
    name: "Compass Deuda Plus Fondo de Inversión",
    shortName: "Deuda Plus",
    fundRun: 7200,
    currency: "CLP",
    fixedFee: "1.19%",
    fundType: "fixedIncome",
    geoDistribution: "Chile",
    rut: "76.133.141-8",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "10732462",
    email: "clientes@dvacapital.com",
    timeHorizon: "LONG",
    icon: "medal",
    redemptionPeriod: "fromFifteenDays",
    color: "#2A7333",
    highestRecommendedProfilingScore: 14,
    retailSeriesNemo: "CFICODPDVA",
  },

  9363: {
    id: "14",
    name: "Compass Global Credit CLP",
    shortName: "Global Credit CLP",
    fundRun: 9363,
    currency: "CLP",
    fixedFee: "1.16%",
    fundType: "fixedIncome",
    geoDistribution: "Global",
    rut: "76.592.492-8",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "10732470",
    email: "clientes@dvacapital.com",
    timeHorizon: "LONG",
    icon: "earth",
    redemptionPeriod: "fromFiveDays",
    color: "#C2651E",
    highestRecommendedProfilingScore: 11,
    retailSeriesNemo: "CFICGGCDVA",
  },
  9364: {
    id: "17",
    name: "Compass Global Credit USD",
    shortName: "Global Credit USD",
    fundRun: 9364,
    currency: "USD",
    fixedFee: "1.19%",
    fundType: "fixedIncome",
    geoDistribution: "Global",
    rut: "76.592.492-8",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "10732470",
    email: "clientes@dvacapital.com",
    timeHorizon: "LONG",
    icon: "earth",
    redemptionPeriod: "fromFiveDays",
    color: "#C2651E",
    highestRecommendedProfilingScore: 11,
    retailSeriesNemo: "CFICGGUDVA",
  },
  9102: {
    id: "15",
    name: "Compass Latam Corporate Debt",
    shortName: "Latam Corporate Debt",
    fundRun: 9102,
    currency: "USD",
    fixedFee: "0.65%",
    fundType: "fixedIncome",
    geoDistribution: "Latinoamérica",
    rut: "76.592.492-8",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "19788282",
    email: "clientes@dvacapital.com",
    timeHorizon: "MEDIUM",
    icon: "domain",
    redemptionPeriod: "fromFiveDays",
    color: "#C2651E",
    highestRecommendedProfilingScore: 11,
    retailSeriesNemo: "CFICLCDVA",
  },
  10235: {
    id: "18",
    name: "Compass Protección",
    shortName: "Protección",
    fundRun: 10235,
    currency: "CLP",
    fixedFee: "1.1305%",
    fundType: "fixedIncome",
    geoDistribution: "Chile",
    rut: "77.550.588-5",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "32732481",
    email: "clientes@dvacapital.com",
    timeHorizon: "SHORT",
    icon: "check-decagram-outline",
    redemptionPeriod: "oneDay",
    color: "#A15BC6", // ADJUST
    highestRecommendedProfilingScore: 11,
    retailSeriesNemo: "CFMCGPRDVA",
  },
  9072: {
    id: "16",
    name: "Compass Deuda Chilena",
    shortName: "Deuda Chilena",
    fundRun: 9072,
    currency: "CLP",
    fixedFee: "1.1305%",
    fundType: "fixedIncome",
    geoDistribution: "Chile",
    rut: "76.618.595-9",
    bank: "BCI - Banco de Crédito e Inversiones",
    accountNumber: "32731931",
    email: "clientes@dvacapital.com",
    timeHorizon: "MEDIUM",
    icon: "star-shooting-outline",
    redemptionPeriod: "oneDay",
    color: "#C43232",
    highestRecommendedProfilingScore: 11,
    retailSeriesNemo: "CFMCGDCDVA",
  },
};

export default {
  methods: {
    getFundStaticData(run) {
      return FUNDS[run];
    },

    getRunList() {
      return Object.keys(FUNDS);
    },

    getFundValues() {
      return Object.values(FUNDS);
    },
  },
};
